import * as Yup from "yup";

export const customerValidationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  branch_id: Yup.number().required("Branch ID is required"),
  email: Yup.string().email("Invalid email format").nullable(),
  phone: Yup.string().nullable(),
  notes: Yup.string().nullable(),
  tags: Yup.string().nullable(),
});
